//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import TransferBetweenWarehouseModel from '@/models/Warehouse/WhTransferBetweenWarehouse'
import TranslatorService from '@/services/translator'
import fields from './fields'

//
export default {
  name: 'dispatch-requests-update',
  components: {
    ModelForm,
  },
  computed: {
    //
    ...mapState('AuthModule', {
      user: 'user',
    }),

    //
    ...mapState('SnackbarModalModule', {
      responseConfirm: 'responseConfirm',
    }),

    /**
     *
     */
    canEdit() {
      return (
        this.$can('EDIT_TRANSFER_BETWEEN_WAREHOUSE') &&
        this.formData.can_dispatch
      )
    },

    /**
     *
     */
    formProps() {
      return {
        editable: false,
        fields: fields({
          g_branch_office_id: this.branchOfficeId,
          triggerWarehouse: this.changeWarehouseFilter,
        }),
        loading: this.formBusy,
        switchEdit: this.canEdit,
        // switchEdit: true, // variable para testear
      }
    },
  },
  data() {
    return {
      branchOfficeId: 1,
      busy: {
        dispatch: false,
      },
      dialogs: {
        guide: false,
      },
      formBusy: false,
      formData: {},
    }
  },
  methods: {
    //
    ...mapActions('MenuesModule', {
      setTitleTopBar: 'setTitleTopBar',
    }),

    //
    ...mapActions('SnackbarModalModule', [
      'resetSnackbarState',
      'setErrorSnackbar',
      'setSuccessSnackbar',
      'setWarningSnackbar',
    ]),

    /**
     *
     */
    changeWarehouseFilter(ctx) {
      this.branchOfficeId =
        ctx.getInput('of_warehouse').getSelected().g_branch_office_id ||
        this.user.hr_employee.g_branch_office_id
    },

    /**
     *
     */
    dispatch(model) {
      return model
        .toDispatch()
        .finally(this.wait)
        .then(this.success)
        .then(this.redirect)
        .catch(this.error)
    },

    /**
     *
     */
    error(error) {
      this.setErrorSnackbar(
        TranslatorService(
          TransferBetweenWarehouseModel,
          error.response.data
        )
      )
    },

    /**
     *
     */
    fetch() {
      TransferBetweenWarehouseModel.modeler()
        .find(this.$route.params.id)
        .then(this.setFormData)
        .then(this.setFormBusy)
    },

    /**
     *
     */
    redirect() {
      this.$router.push({ name: 'transfer-between-warehouse' })
    },

    /**
     *
     */
    reset() {
      this.setFormBusy(true).then(this.fetch)
    },

    /**
     *
     */
    async setFormBusy(formBusy = false) {
      this.formBusy = formBusy
    },

    /**
     *
     */
    setFormData(model) {
      this.branchOfficeId = this.user.hr_employee.g_branch_office_id
      this.formData = model.reset({ user: this.user })
    },

    showWithDispatchGuide() {
      this.dialogs.guide = true
    },

    /**
     *
     */
    success() {
      this.setSuccessSnackbar('Guía de intercambio despachada.')
    },

    /**
     *
     */
    submit() {
      this.showWithDispatchGuide()
    },

    /**
     * 
     */
    async submitWithGuide() {
      this.busy.dispatch = true
      this.formData.generate_dispatch_guide = true
      await this.$refs.form.setWait(true).then(this.dispatch)
      this.dialogs.guide = false
      this.busy.dispatch = false
    },

    /**
     * 
     */
    async submitWithoutGuide() {
      this.busy.dispatch = true
      this.formData.generate_dispatch_guide = false
      await this.$refs.form.setWait(true).then(this.dispatch)
      this.dialogs.guide = false
      this.busy.dispatch = false
    },

    /**
     *
     */
    wait(val) {
      return this.$refs.form.setWait(val)
    },
  },
  beforeMount() {
    this.setTitleTopBar('Despacho de guía de intercambio')
  },
  mounted() {
    this.reset()
  },
  beforeRouteEnter(to, from, next) {
    next(ctx => {
      if (!ctx.$can('VIEW_DETAIL_TRANSFER_BETWEEN_WAREHOUSE'))
        ctx.$router.push('/')
    })
  },
}
